

















































import {Component, Mixins} from "vue-property-decorator";
import Dialog from "@/mixins/Dialog";
import ConfirmDialog from "@/components/confirmDialog.vue";

@Component({
  components: {
    'confirm-dialog' : ConfirmDialog
  }
})
export default class CustodianApplyDialog extends Mixins(Dialog){

  //弹窗显示
  private dialog:any={
    confirmDialog:false
  }

  // 表单参数
  private params:any={
    organ_name: "",
    type: 1,
    legal_name: "",
    contact: "",
    email: "",
    plat_id: 76
  }

  //校验参数
  private rules:any={
    organ_name: [
      {required: true, message: '请输入机构名称', trigger: 'blur'}
    ],
    legal_name: [
      {required: true, message: '请输入负责人姓名', trigger: 'blur'}
    ],
    contact: [
      {required: true, message: '请输入负责人手机号', trigger: 'blur'}
    ],
    email: [
      {required: true, message: '请输入负责人邮箱', trigger: 'blur'}
    ],
  }

  public open(){
    this.dialog_visible = true ;
  }

  //提交
  private submit(){

    let form = (this.$refs as any).dialog_form;
    form.validate((valid:any) => {
      if (valid) {
        let data :any={};
        Object.assign( data, this.params );
        console.log( data , '破产管理人申请' );
        this.loading = true;
        this.$noSign.post(this.$URL.ENTERPRISE_APPLY , data ).then((res:any)=>{
          this.loading = false;
          if(res.code == 1){
            console.log( res , data, '破产管理人申请成功');
            (this.$refs as any).confirmDialog.open( '提交成功，待审核' , 'success' )
          }else{
            this.$message.error( res.msg )
          }
        })
      }
    });
  }

  private complete(){
    this.onClose();
  }

  public onClose(){
    let form = (this.$refs as any).dialog_form;
    form.resetFields();
    this.dialog_visible = false ;
  }
}
